/**
 * @generated SignedSource<<9e73ef148e17d2b5a9de5dc0b9fa9c7c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type EventSchedulerQuery$variables = {
  calendarIds: ReadonlyArray<string | null>;
};
export type EventSchedulerQuery$data = {
  readonly viewer: {
    readonly " $fragmentSpreads": FragmentRefs<"EventScheduler_viewer">;
  };
};
export type EventSchedulerQuery = {
  variables: EventSchedulerQuery$variables;
  response: EventSchedulerQuery$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "calendarIds"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "calendarIds",
    "variableName": "calendarIds"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "emails",
  "storageKey": null
},
v3 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 1000000
  }
],
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "concreteType": "WorkingSetting",
  "kind": "LinkedField",
  "name": "setting",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "minSlot",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "maxSlot",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "excludedSlots",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v7 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "targetCalendarId",
    "storageKey": null
  },
  (v4/*: any*/)
],
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "message",
  "storageKey": null
},
v9 = {
  "kind": "InlineFragment",
  "selections": [
    (v8/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "statusCode",
      "storageKey": null
    }
  ],
  "type": "GraphEntityError",
  "abstractKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "connected",
  "storageKey": null
},
v11 = {
  "kind": "InlineFragment",
  "selections": [
    (v4/*: any*/)
  ],
  "type": "Node",
  "abstractKey": "__isNode"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "EventSchedulerQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "args": (v1/*: any*/),
            "kind": "FragmentSpread",
            "name": "EventScheduler_viewer"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "EventSchedulerQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "User",
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": (v3/*: any*/),
                "concreteType": "OrgConnection",
                "kind": "LinkedField",
                "name": "orgs",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "OrgEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Org",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": [
                              {
                                "kind": "Literal",
                                "name": "resolveOverrides",
                                "value": false
                              }
                            ],
                            "concreteType": "UserWorkingHours",
                            "kind": "LinkedField",
                            "name": "userWorkingHours",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "WorkingHours",
                                "kind": "LinkedField",
                                "name": "workingHours",
                                "plural": false,
                                "selections": [
                                  (v4/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "type",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "timeZone",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "DaySetting",
                                    "kind": "LinkedField",
                                    "name": "daySettings",
                                    "plural": true,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "day",
                                        "storageKey": null
                                      },
                                      (v5/*: any*/)
                                    ],
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "DayOverride",
                                    "kind": "LinkedField",
                                    "name": "dayOverrides",
                                    "plural": true,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "date",
                                        "storageKey": null
                                      },
                                      (v5/*: any*/)
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              },
                              (v4/*: any*/)
                            ],
                            "storageKey": "userWorkingHours(resolveOverrides:false)"
                          },
                          (v4/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "experiments",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "nextDefragTime",
                            "plural": false,
                            "selections": [
                              (v6/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "millis",
                                    "storageKey": null
                                  }
                                ],
                                "type": "DefragTime",
                                "abstractKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": (v3/*: any*/),
                            "concreteType": "SuggestedOrgInviteConnection",
                            "kind": "LinkedField",
                            "name": "suggestedInvites",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "SuggestedOrgInviteEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "SuggestedOrgInvite",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": (v7/*: any*/),
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": "suggestedInvites(first:1000000)"
                          },
                          {
                            "alias": null,
                            "args": (v3/*: any*/),
                            "concreteType": "OrgInviteConnection",
                            "kind": "LinkedField",
                            "name": "pendingInvites",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "OrgInviteEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "OrgInvite",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": (v7/*: any*/),
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": "pendingInvites(first:1000000)"
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "domains",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "primaryOrgCalendar",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": (v1/*: any*/),
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "personsByCalendarIdsErrorable",
                            "plural": false,
                            "selections": [
                              {
                                "kind": "TypeDiscriminator",
                                "abstractKey": "__isPersonListErrorable"
                              },
                              (v6/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "Person",
                                    "kind": "LinkedField",
                                    "name": "list",
                                    "plural": true,
                                    "selections": [
                                      (v4/*: any*/),
                                      (v2/*: any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "primaryEmail",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "primaryCalendar",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "UserProfile",
                                        "kind": "LinkedField",
                                        "name": "profile",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "givenName",
                                            "storageKey": null
                                          },
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "familyName",
                                            "storageKey": null
                                          },
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "externalImageUrl",
                                            "storageKey": null
                                          }
                                        ],
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "isYou",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "isOutsideOrg",
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "type": "PersonList",
                                "abstractKey": null
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v8/*: any*/)
                                ],
                                "type": "GraphEntityError",
                                "abstractKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "zoomAccount",
                            "plural": false,
                            "selections": [
                              (v6/*: any*/),
                              (v9/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "accountId",
                                    "storageKey": null
                                  },
                                  (v10/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "displayName",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "hasValidZoomAccount",
                                    "storageKey": null
                                  }
                                ],
                                "type": "ZoomAccount",
                                "abstractKey": null
                              },
                              (v11/*: any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "zoomUserLevelAccount",
                            "plural": false,
                            "selections": [
                              (v6/*: any*/),
                              (v9/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v10/*: any*/)
                                ],
                                "type": "ZoomAccount",
                                "abstractKey": null
                              },
                              (v11/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "orgs(first:1000000)"
              },
              (v4/*: any*/)
            ],
            "storageKey": null
          },
          (v4/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "f51a45353ae5ca196e61297bc391ed88",
    "id": null,
    "metadata": {},
    "name": "EventSchedulerQuery",
    "operationKind": "query",
    "text": "query EventSchedulerQuery(\n  $calendarIds: [String]!\n) {\n  viewer {\n    ...EventScheduler_viewer_3nh1j1\n    id\n  }\n}\n\nfragment AutopilotFlexibility_org on Org {\n  userWorkingHours(resolveOverrides: false) {\n    workingHours {\n      id\n      type\n      timeZone\n      daySettings {\n        day\n        setting {\n          minSlot\n          maxSlot\n          excludedSlots\n        }\n      }\n      dayOverrides {\n        date\n        setting {\n          minSlot\n          maxSlot\n          excludedSlots\n        }\n      }\n    }\n    id\n  }\n}\n\nfragment AutopilotForm_org on Org {\n  ...AutopilotFlexibility_org\n  id\n  experiments\n  nextDefragTime {\n    __typename\n    ... on DefragTime {\n      millis\n    }\n  }\n  suggestedInvites(first: 1000000) {\n    edges {\n      node {\n        targetCalendarId\n        id\n      }\n    }\n  }\n  pendingInvites(first: 1000000) {\n    edges {\n      node {\n        targetCalendarId\n        id\n      }\n    }\n  }\n}\n\nfragment EventSchedulerAttendeeInput_personsByCalendarIdsErrorable on PersonListErrorable {\n  __isPersonListErrorable: __typename\n  __typename\n  ... on PersonList {\n    list {\n      id\n      emails\n      primaryEmail\n      primaryCalendar\n      profile {\n        givenName\n        familyName\n        externalImageUrl\n      }\n      isYou\n      isOutsideOrg\n    }\n  }\n  ... on GraphEntityError {\n    message\n  }\n}\n\nfragment EventScheduler_viewer_3nh1j1 on Viewer {\n  user {\n    emails\n    orgs(first: 1000000) {\n      edges {\n        node {\n          ...AutopilotForm_org\n          ...AutopilotFlexibility_org\n          id\n          domains\n          primaryOrgCalendar\n          experiments\n          personsByCalendarIdsErrorable(calendarIds: $calendarIds) {\n            ...EventSchedulerAttendeeInput_personsByCalendarIdsErrorable\n            __typename\n            ... on PersonList {\n              list {\n                id\n                emails\n                primaryEmail\n                profile {\n                  givenName\n                  familyName\n                  externalImageUrl\n                }\n                isYou\n                isOutsideOrg\n              }\n            }\n            ... on GraphEntityError {\n              message\n            }\n          }\n          zoomAccount {\n            __typename\n            ... on GraphEntityError {\n              message\n              statusCode\n            }\n            ... on ZoomAccount {\n              accountId\n              connected\n              displayName\n              hasValidZoomAccount\n            }\n            ... on Node {\n              __isNode: __typename\n              id\n            }\n          }\n          zoomUserLevelAccount {\n            __typename\n            ... on GraphEntityError {\n              message\n              statusCode\n            }\n            ... on ZoomAccount {\n              connected\n            }\n            ... on Node {\n              __isNode: __typename\n              id\n            }\n          }\n        }\n      }\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "53eb4550af00c8e2f0abe48eb4c3435f";

export default node;
